import { render, staticRenderFns } from "./Stageindex.vue?vue&type=template&id=10854a04&scoped=true"
import script from "./Stageindex.vue?vue&type=script&lang=js"
export * from "./Stageindex.vue?vue&type=script&lang=js"
import style0 from "./Stageindex.vue?vue&type=style&index=0&id=10854a04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10854a04",
  null
  
)

export default component.exports